// Do not use outside of its respective selector
import { createSelector } from 'reselect'
import { DialogId } from '@feedyou/schema'

import {
  buildDialogHierarchyMap,
  DialogHierarchyMap,
  getDirectEnabledSubdialogsForDialog,
  getDirectSubdialogsForDialog
} from '../../../features/dialogRelation'
import { dialogsArraySelector } from './dialogsArraySelector'
import type { RootState } from '../../../reducers'
import { botFlowSelector } from './botFlowSelector'
import { featureValueSelector } from '../../features/selectors'
import { createStableEntryPointChildMapCreator } from '../../../lib/dialogs/createStableEntryPointChildMap'
import { makeStableDialogChildMapCreator } from '../../../lib/dialogs/makeStableChildMapCreator'

const dialogChildMapSelector = createSelector(
  (state: RootState) => dialogsArraySelector(state),
  makeStableDialogChildMapCreator(d => getDirectSubdialogsForDialog(d))
)

const dialogEnabledChildMapSelector = createSelector(
  (state: RootState) => dialogsArraySelector(state),
  makeStableDialogChildMapCreator(d => getDirectEnabledSubdialogsForDialog(d))
)

const entryPointChildMapSelector = createSelector(
  (state: RootState) => botFlowSelector(state),
  createStableEntryPointChildMapCreator()
)

export const dialogHierarchyMapSelector = createSelector(
  (state: RootState) => dialogChildMapSelector(state),
  (state: RootState) => dialogEnabledChildMapSelector(state),
  (state: RootState) => entryPointChildMapSelector(state),
  (state: RootState) => featureValueSelector('IMPROVED_DIALOG_MAP')(state),
  (childMap, enabledConnectionsChildMap, entryPointChildMap, newAlgoEnabled): DialogHierarchyMap =>
    buildDialogHierarchyMap(
      childMap,
      enabledConnectionsChildMap,
      entryPointChildMap,
      !!newAlgoEnabled
    )
)

export function dialogHierarchyDescriptorSelector(id: DialogId) {
  return function dialogHierarchyDescriptorSelector(state: RootState) {
    return dialogHierarchyMapSelector(state).get(id)
  }
}
